import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["onUpdate:modelValue"]
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      _cache[1] || (_cache[1] = _createTextVNode(" Ger Ita ")),
      _createElementVNode("button", {
        class: "btn btn-sm btn-success ms-1",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)))
      }, "+")
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "d-flex align-items-center",
        key: i
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": ($event: any) => ((item.ger) = $event),
          placeholder: "GER",
          class: "form-control me-1"
        }, null, 8, _hoisted_2), [
          [_vModelText, item.ger]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": ($event: any) => ((item.ita) = $event),
          placeholder: "ITA",
          class: "form-control mx-1"
        }, null, 8, _hoisted_3), [
          [_vModelText, item.ita]
        ]),
        _createElementVNode("button", {
          class: "btn btn-sm btn-danger ms-1",
          onClick: ($event: any) => (_ctx.removeIndex(i))
        }, " - ", 8, _hoisted_4)
      ]))
    }), 128))
  ]))
}